import { useEffect, useRef } from 'react';
import { Pen } from 'lucide-react';

export const SignatureCanvas = ({ onChange, testId = 'signature-canvas' }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef({ x: 0, y: 0 });
  const dirty = useRef(false);

  const point = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const src = e.touches && e.touches[0] ? e.touches[0] : e;
    return { x: src.clientX - rect.left, y: src.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = point(e); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext('2d');
    const p = point(e);
    ctx.strokeStyle = '#1a3650'; ctx.lineWidth = 2.5; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last.current = p; dirty.current = true;
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (onChange && dirty.current) onChange(canvasRef.current.toDataURL('image/png'));
  };
  const clear = () => {
    const c = canvasRef.current;
    c.getContext('2d').clearRect(0, 0, c.width, c.height);
    dirty.current = false;
    if (onChange) onChange('');
  };

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    c.getContext('2d').scale(ratio, ratio);
  }, []);

  return (
    <div>
      <canvas
        ref={canvasRef}
        className="w-full h-40 bg-white border-2 border-gray-300 rounded-lg cursor-crosshair touch-none"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        data-testid={testId}
      />
      <div className="flex justify-between mt-1">
        <p className="text-xs text-gray-500 flex items-center gap-1"><Pen className="w-3 h-3" />Teken hier je handtekening</p>
        <button type="button" onClick={clear} className="text-xs text-gray-500 hover:text-red-500 underline" data-testid={`${testId}-clear`}>Wissen</button>
      </div>
    </div>
  );
};
